import * as Component from 'components';
import {
  TransferDataHandlerInterface,
  TransferDataSourceInterface,
} from 'components/transfer/Transfer';
import { additionalContentService } from 'content/library/service/additionalContentService';
import { libraryService } from 'content/library/service/libraryService';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const ClipTrailerComponent: React.FC = () => {
  const { id } = useParams();
  const [contentTypeFilter, setContentTypeFilter] = useState<string>('clip,trailer,additional');
  const [refreshKey, setRefreshKey] = useState(0);

  const dataHandler: TransferDataHandlerInterface = {
    fetchSourceData: async (
      query: Record<string, string>
    ): Promise<{ data: TransferDataSourceInterface[]; count: number }> => {
      const searchParams = new URLSearchParams(query);
      // Use selected content type filter
      searchParams.set('content_type', contentTypeFilter);
      // Set default order_by if not provided or empty
      if (!searchParams.has('order_by') || !searchParams.get('order_by')) {
        searchParams.set('order_by', 'id');
      }
      const { results: clipList, count } = await libraryService.fetch(searchParams);
      return {
        data: clipList.map(clip => ({
          key: clip.id,
          name: clip.title,
          disabled: false,
          id: clip.id,
          content_type: clip.content_type,
        })),
        count,
      };
    },
    fetchTargetData: async (query: Record<string, string>) => {
      const searchParams = new URLSearchParams(query);
      // Use selected content type filter
      searchParams.set('content_type', contentTypeFilter);
      // Set default order_by if not provided or empty
      if (!searchParams.has('order_by') || !searchParams.get('order_by')) {
        searchParams.set('order_by', 'id');
      }
      searchParams.set('origin_id', String(id));
      searchParams.set('origin_type', 'content');

      const { results: clipList, count } =
        await additionalContentService.fetchAdditionalContent(searchParams);

      return {
        data: clipList.map(clip => ({
          key: clip.id,
          name: clip.title,
          disabled: false,
          id: clip.id,
          content_type: clip.content_type,
        })),
        count,
      };
    },
    createWithParentId: async (ids: number[]) => {
      // Create links for both clip and trailer content types
      await additionalContentService.createAdditionalContentLink(
        Number(id),
        'content',
        ids,
        'clip'
      );
    },
    deleteWithParentId: async (ids: number[]) => {
      await additionalContentService.deleteAdditionalContentLink(Number(id), ids);
    },
  };
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Content Type',
      dataIndex: 'content_type',
      key: 'content_type',
    },
  ];
  return (
    <Component.TransferComponent
      key={refreshKey}
      dataHandler={dataHandler}
      columns={columns}
      filterOptions={[
        { label: 'All (Clip + Trailer + Additional)', value: 'clip,trailer,additional' },
        { label: 'Clip Only', value: 'clip' },
        { label: 'Trailer Only', value: 'trailer' },
        { label: 'Additional Only', value: 'additional' },
      ]}
      filterValue={contentTypeFilter}
      onFilterChange={value => {
        setContentTypeFilter(value);
        setRefreshKey(prev => prev + 1);
      }}
    />
  );
};

export default ClipTrailerComponent;
